import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import './Register.css'

import { auth }  from './firebase'
export default function Register() {
    const history = useHistory()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmpassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')

  const registerbutton =(e)=>{
    e.preventDefault()
    if(confirmpassword!== password){
        setError('Password not match')
        
    }else{

    setError('')
    auth.createUserWithEmailAndPassword(email, password).then((auth)=>{
        console.log(auth);
        if(auth){
            history.push('/login')
        }
    }).catch(err => console.log(err))  
}
   }
  return (
    <div className='login' >
        <Link to='/'>
         <img className="login_logo"src='https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png' 
            alt=''    />
            </Link>
       <div className='login_container' >
           <h1>Sign-Up</h1>
           {error && <h4 style={{color:"red", textAlign:"center" }}>{error}</h4>}
           <form>
               <h4>E-mail</h4>
               <input type="email"  value={email} onChange ={e => setEmail(e.target.value)} required />
               <h4>Password</h4>
               <input type="password" value={password} onChange ={e => setPassword(e.target.value)}  required />
               <h4>Confirm Password</h4>
               <input type="password" value={confirmpassword} onChange ={e => setConfirmPassword(e.target.value)} required />
               <button className='signinButton' onClick={ registerbutton}  >Sign Up</button>
           </form>
           <br/>
         <hr/>
         <p style={{textAlign:"center"}} >Already have a account <Link to='/login' >Sign in</Link></p>
         
       </div>
       <hr/>
    </div>
  )
}
